module.exports = __webpack_public_path__ + "static/media/Carlos_Javier_Sanchez_Mancilla.7aec06e8.png";